<template>
    

    <div class="card">

        <div class="card-header d_f jc_sb">
            <div class="d_f">
                <img src="../../assets/icon1.png" alt="" class="card-img">
                <h3 class="d_f d_f_c jc_sb" :class="titleStyle?'c_white':'c_black'">
                    <p class="P_sl title">{{title}}</p>
                    <span class="P_s desc">{{desc}}</span>
                </h3>
            </div>
            <router-link v-if="link.to" :to='link.to' class="d_f ai_c link">
                {{link.name}}
                <img src="../../assets/jt.png" class="jt"/>
            </router-link>
        </div>

        <slot></slot>

    </div>



</template>



<script>
export default {
    props : {
        title : {
            type : String ,
            required: true,
        },
        desc : {
            type : String ,
            required: true,
        },
        img : {
            type : String ,
            required: true,
        },
        link : {
            type : Object,
            default: function () {
                return { to: null , name : null }
            }
        },
        titleStyle:{
            type: Boolean,
            default: function () {
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .card-header{
        height: 52px;
        margin-bottom: 40px;
    }
    h3,p{
        margin:0;
    }
    .card-img{
        width: 18px;
        height: 32px;
        margin-right: 20px;
        margin-top: 5px;
    }
    .jt{
        width: 16px;
        height: 16px;
        margin-left: 3px;
    }
    .link{
        font-size: 18px;
    }

    @media screen and (max-width: 750px) {
        .card-header{
            height: 12.979vw;
            margin-bottom: 3.989vw;
            padding: 0 2.66vw;
        }
        .card-img{
            width: 2.394vw;
            height: 4.255vw;
            margin-right: 1.33vw;
            margin-top: 1.862vw;
        }
        .jt{
            width: 2.66vw;
            height: 2.66vw;
            margin-left: 0.798vw;
        }
        .link{
            font-size: 3.458vw;
        }
        .title{
            font-size: 1.5818rem;
            font-family: "Tensentype-XiChaoHeiJ";
        }
        .desc{
            font-size:2.66vw;
            font-family: "SourceHanSansCN-Light";
        }
    }
</style>